export default __webpack_public_path__ + "locales/uk-UA/WebPlugins.json?hash=def69b0d4844422aa604398ee46ce5b6";